import getApi from '../../api'
import { SideEffect } from '../../model/Drug'

export const getSideEffects = (search: string, signal?: AbortSignal) =>
  getApi().get<Array<SideEffect>>(`/side_effects`, { search }, { signal })
